"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 5v14H5V5zm2-2H3v18h18z"
}), 'CheckBoxOutlineBlankSharp');